/**
 * Styled Components - Created by cazarez on 10/04/18.
 */
import styled from 'styled-components'
import { GRAY_DARK } from '../../theme/colors'

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 24px;
  font-weight: bold;
  height: 33px;
  letter-spacing: 0.3px;
  line-height: 33px;
  margin: 24px 0;
  text-align: center;
  width: 100%;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const Container = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 48px;
  position: relative;
  font-family: Avenir;
  #filters {
    display: flex;
    justify-content: space-between;
  }
  #srch {
    padding: 5px 8px !important;
    border-radius: 25px !important;
    border-bottom: none;
    width: 328px;
    border: 1px solid #e9e9e9;
    background: #fcfcfc;
    text-align: center;
    position: relative;
    left: calc(50% - 168px);
    &:focus {
      border-color: black !important;
    }
    @media (max-width: 698px) {
      left: -18px;
    }
  }
  #sortOptions {
    width: 162px;
    transition: all .25s;
    align-self: flex-end;
    & .ant-select-selection {
      border-radius: 25px;
      height: 28px;
      border: 1px solid #e9e9e9;
      background: #f8f8f8;
    }
    .ant-select-selection-selected-value {
      padding-right: 8px;
    }
    .ant-select-selection__rendered {
      line-height: 26px;
      font-size: 13px;
      margin-left: 12px;
      margin-right: 12px;
    }
    .ant-select-selection__placeholder {
      color: #a4a4a4;
    }
  }
  #listContainer {
    width: 100%;
    max-width: 1300px;
    display: flex;
    flex-flow: column;
    min-height: 50vh;
    transition: all .25s;
  }
  .ant-spin {
    height: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-pagination {
    align-self: center;
  }
  #list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
    justify-content: center;
  }
  .card {
    display: flex;
    flex-flow: column;
    margin-right: 10px;
    font-family: Avenir;
    margin-bottom: 28px;
    position: relative;
    @media (max-width: 698px) {
      margin-right: 6px;
      margin-left: 8px;
    }
  }
  .thmbnl {
    max-width: 198px;
    min-width: 128px;
    border-radius: 3px;
    @media (max-width: 698px) {
      max-width: 176px;
    }
  }
  .quickIcon {
    max-width: 17px;
    transition: all .25s;
    background: #f1f4f561;
    border-radius: 25px;
    position: absolute;
    left: 8px;
    top: 8px;
    &:hover {
      cursor: pointer;
      filter: brightness(1) drop-shadow(0px 0px 1px gray);
    }
  }
  .name {
    font-weight: bold;
    margin-block: 9px 4px;
    font-size: 16px;
  }
  .dscrptr, .name {
    margin-left: 4px;
  }
  .lnk {
    margin-top: 5px;
    color: cornflowerblue;
    font-weight: 500;
    i {
      margin-right: 10px;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductTemplates/styledComponents.tsx